import React from "react";
import AllBlogs from './components/AllBlogs'
export const Blogs = () => {
  return (
    <div>
        <AllBlogs />
    </div>
  )
};
